import React from 'react'
import {Autoplay} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';

import 'swiper/css';

const ImageSlider = ({data, teamMembers}) => {
  const {title, content, button} = data

  if (typeof window === "undefined") {
    return <p>Server Render</p>
  }
  const team = teamMembers.flatMap(department => {
    return department.teamMembers.nodes.map(member => {
      return {
        ...member,
        department: department.name
      }
    });
  });

  return (
    <section className="slider-wrapper">
      <div className="content-wrapper">
        {title && (
          <h5>{title}</h5>
        )}
        {content && (
          <div dangerouslySetInnerHTML={{__html: content}}></div>
        )}
        {button && (
          <a className="btn button-solid" href={button.url}>{button.title}</a>
        )}
      </div>
      <div className="image-slider">
        <Swiper
          modules={[Autoplay]}
          slidesPerView={3}
          loop={true}
          autoHeight={true}
          spaceBetween={10}
          autoplay
          direction={'horizontal'}
        >
          {team ? team.map((member, i) => (
            <React.Fragment key={i}>
              {member.featuredImage ? (
                <SwiperSlide>
                  <img alt={member.title} src={member.featuredImage.node?.sourceUrl}/>
                </SwiperSlide>
              ) : ''}
            </React.Fragment>
          )) : null}
        </Swiper>
      </div>
    </section>
  )
}

export default ImageSlider
